import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-splash-page',
  standalone: false,
  templateUrl: './splash-page.component.html',
  styleUrl: './splash-page.component.css',
})
export class SplashPageComponent implements OnInit {
  constructor(private auth: AuthService, private router: Router) {}

  async ngOnInit(): Promise<void> {
    try {
      await this.auth.tryLoginIfNeeded();
      if (!this.auth.isLoggedIn()) { this.auth.login(); return; }
      await this.auth.loadStaffAccess();
      await this.router.navigateByUrl(this.auth.landingPage());
    } catch {
      await this.router.navigateByUrl('/unauthorized');
    }
  }
}
